import { render, staticRenderFns } from "./TenantDeleteAlert.vue?vue&type=template&id=191e8a92&"
import script from "./TenantDeleteAlert.vue?vue&type=script&lang=ts&"
export * from "./TenantDeleteAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VAlert,VDivider})
